import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import _ from 'lodash';

import Modal from '../../lib/layout/Modal';
import Row from '../../lib/layout/Row';
import Column from '../../lib/layout/Column';
import FormContainer from '../../lib/forms/FormContainer';
import TextInput from '../../lib/forms/TextInput';
import SubmitButton from '../../lib/forms/SubmitButton';
import { useResetPasswordMutation } from '../../lib/ascertis-api';
import * as CONSTANTS from '../../utils/constants';

const Schema = Yup.object().shape({
  email: Yup.string().email().required()
});

const PasswordResetForm = () => {
  const [modalMessage, setModalMessage] = useState(undefined);
  const [requestPassword] = useResetPasswordMutation();
  const showModal = !_.isEmpty(modalMessage);

  const handleSubmit = async (formValues) => {
    const params = {
      ...formValues,
      redirectUrl: `${CONSTANTS.HOST}/user/password/edit`
    };
    await requestPassword({ params }).unwrap()
      .then((payload) => {
        // Take any success actions here
        setModalMessage('Please check your email. You should receive a link to reset your password.');
      }).catch((error) => {
        setModalMessage(error);
      });
  };
  const handleClose = () => setModalMessage(undefined);

  return (
    <div id="password-reset-form">
      <Modal id="authentication-modal" open={showModal} onClose={handleClose}>
        { modalMessage }
      </Modal>
      <FormContainer title="Request Password Reset">
        <Formik
          initialValues={{ email: '' }}
          validationSchema={Schema}
          onSubmit={(values, actions) => {
            return handleSubmit(values, actions);
          }}
        >
          {props => (
            <Form role="form">
              <Row>
                <Column small={12}>
                  <Field name="email" prompt="Email" component={TextInput} />
                </Column>
              </Row>
              <Row className="form-button-container right-align">
                <SubmitButton>Request Password Reset</SubmitButton>
              </Row>
            </Form>
          )}
        </Formik>
      </FormContainer>
    </div>
  );
};

PasswordResetForm.propTypes = {};


export default PasswordResetForm;
